import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "utils/useDidMountEffect";
import apiUser from "apiUser";
import {get, has, set} from "lodash";
import {Table} from "reactstrap";
import moment from "moment";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import TypeDetailsLabel from "./TypeDetailsLabel";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";

const TypeDetails = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [typeDetails, setTypeDetails] = useState(null)

  useDidMountEffect(() => {
    apiUser.tecRmi.vehicleTree.typeDetails(getApiPrimaryParams())
      .then(res => {
        if(res.data[0]){
          setTypeDetails(parseTypeDetails(res.data[0]))
        }
      })
      .catch(() => {
        if(props.onGetTypeDetailsError){
          props.onGetTypeDetailsError()
        }
      })
  })

  useAfterUpdateEffect(() => {
    if(props.onTypeDetailsFetched){
      props.onTypeDetailsFetched(typeDetails)
    }
  }, [typeDetails])

  const parseTypeDetails = (typeDetails) => {
    let typeDetailsNew = {}

    typeDetails.TypeDetails.forEach(typeDetail => {
      if([3,4].includes(typeDetail.AddInfoKeyId)){
        typeDetail.AddInfoKeyValue = moment(typeDetail.AddInfoKeyValue).format('YYYY-MM')
      }

      if(!has(typeDetailsNew, typeDetail.AddInfoKeyId)){
        set(typeDetailsNew, typeDetail.AddInfoKeyId, {
          ...typeDetail,
          values: [typeDetail.AddInfoKeyValue]
        })
      }else{
        set(typeDetailsNew, typeDetail.AddInfoKeyId, {
          ...get(typeDetailsNew, typeDetail.AddInfoKeyId),
          values: [
            ...get(typeDetailsNew, typeDetail.AddInfoKeyId).values,
            typeDetail.AddInfoKeyValue
          ]
        })
      }
    })

    typeDetails.TypeDetails = Object.values(typeDetailsNew)

    return typeDetails
  }

  if(!typeDetails){
    return <LoadingSpinner />
  }

  return <Table className="table-bordered">
    <tbody>
    <tr>
      <td><strong>Typ pojazdu</strong></td>
      <td><TypeDetailsLabel typeDetails={typeDetails} /></td>
    </tr>
    {typeDetails.TypeDetails.map((typeDetail, key) => <tr key={key.toString()}>
      <td><strong>{typeDetail.AddInfoKeyName}</strong></td>
      <td>{typeDetail.values.join(', ')}</td>
    </tr>)}
    </tbody>
  </Table>;
};

TypeDetails.propTypes = {
  onTypeDetailsFetched: PropTypes.func,
  onGetTypeDetailsError: PropTypes.func,
};

export default TypeDetails;